import { useCallback, useMemo } from "react";
import { useSWRConfig } from "swr";

import { SetDefaultOrganizationRequest } from "@account/models/SetDefaultOrganizationRequest";
import { putData } from "@api/crud";

import { userEndpoints } from "./endpoints";

export function useSetDefaultOrganization() {
  const { mutate } = useSWRConfig();

  const update = useCallback(
    async (organizationId: string) => {
      const url = userEndpoints.setDefaultOrganization();

      const request: SetDefaultOrganizationRequest = {
        organizationId: organizationId
      };
      const result = await putData<SetDefaultOrganizationRequest>(url, request);
      await mutate(userEndpoints.getDefaultOrganization());
      return result;
    },
    [mutate]
  );

  return useMemo(() => ({ update }), [update]);
}
